import React, { useEffect } from "react";
import "./Banner.css";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay,Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { getHomeBanner } from "../../../features/home/homeSlice";
import { useDispatch, useSelector } from "react-redux";

function Banner() {

  //const data = ["/assets/images/home/banner/banner1.png", "/assets/images/home/banner/banner2.png","/assets/images/home/banner/banner3.png"]

  const banners = useSelector((state) => state.home.banners)
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getHomeBanner());
  }, []);
  //console.log("jdcjdv",banners);


  return (
    <section className="Banner">
      <div className="">
        <Swiper
          spaceBetween={15}
          pagination={{
            dynamicBullets: true,
            clickable: true
          }}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          modules={[Autoplay, Pagination]}
          className="banner_swiper"
          breakpoints={{
            0: {
              slidesPerView: 1,
            },

          }}
        >
          {banners?.length > 0 && banners?.map((item) => {
            return (
              <SwiperSlide >
                <div className='img_holder'>
                  <img src={process.env.REACT_APP_IMG_URL + item.website_image} className='image' />
                </div>
              </SwiperSlide>
            )
          })}
        </Swiper>
      </div>
    </section>
  );
}

export default Banner;
//   return (
//     <section className="Banner">
//       <div className="">
//         <Swiper
//           spaceBetween={15}
//           pagination={{
//             dynamicBullets: true,
//             clickable: true
//           }}
//           modules={[Pagination]}
//                 <div className='img_holder'>
//                   <img src={item} className='image' />
//                 </div>
//               </SwiperSlide>
//             )
//           })}
//         </Swiper>
//       </div>
//     </section>
//   );
// }

// export default Banner;/           autoplay={{ delay: 300 }}
//           className="banner_swiper"
//           breakpoints={{
//             0: {
//               slidesPerView: 1,
//             },

//           }}
//         >
//           {data?.length > 0 && data?.map((item) => {
//             return (
//               <SwiperSlide >


